/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PurchaseMarketplaceListingResponse } from '../../models/purchase-marketplace-listing-response';

export interface MarketplaceServicePurchaseMarketplaceListing$Params {
  marketplaceListingId: string;
  discordId?: string;
  userUuid?: string;
}

export function marketplaceServicePurchaseMarketplaceListing(http: HttpClient, rootUrl: string, params: MarketplaceServicePurchaseMarketplaceListing$Params, context?: HttpContext): Observable<StrictHttpResponse<PurchaseMarketplaceListingResponse>> {
  const rb = new RequestBuilder(rootUrl, marketplaceServicePurchaseMarketplaceListing.PATH, 'post');
  if (params) {
    rb.path('marketplaceListingId', params.marketplaceListingId, {});
    rb.query('discordId', params.discordId, {});
    rb.query('userUuid', params.userUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PurchaseMarketplaceListingResponse>;
    })
  );
}

marketplaceServicePurchaseMarketplaceListing.PATH = '/api/v3/gateway/marketplace/listing/{marketplaceListingId}/purchase';
